import { trpc } from "./trpc";

/**
 * Thin wrappers around react-query/trpc mutations for Account.
 */
export function useAccountMutation() {
  const utils = trpc.useUtils();

  const {
    mutate: updateSubscriptionItem,
    isPending: isLoadingUpdateSubscriptionItem,
  } = trpc.account.updateSubscriptionItem.useMutation({
    onSettled() {
      utils.account.getBilling.invalidate();
    },
  });

  const { mutate: resubscribe, isPending: isResubscribing } =
    trpc.account.resubscribe.useMutation({
      onSettled() {
        utils.account.getBilling.invalidate();
        utils.account.planUsage.invalidate();
        utils.identity.get.invalidate();
      },
    });

  const { mutate: chooseFreePlan, isPending: isChoosingFreePlan } =
    trpc.account.chooseFreePlan.useMutation({
      onSettled() {
        utils.account.getBilling.invalidate();
        utils.account.planUsage.invalidate();
        utils.identity.get.invalidate();
      },
    });

  const { mutate: changePlan, isPending: isChangingPlan } =
    trpc.account.changePlan.useMutation({
      onSettled() {
        utils.account.getBilling.invalidate();
        utils.identity.get.invalidate();
      },
    });

  const {
    mutate: cancelPendingPlanChange,
    isPending: isCancellingPendingPlanChange,
  } = trpc.account.cancelPendingPlanChange.useMutation({
    onSettled() {
      utils.account.getBilling.invalidate();
    },
  });

  const { mutate: keepSubscription, isPending: isKeepingSubscription } =
    trpc.account.keepSubscription.useMutation({
      onSettled() {
        utils.account.getBilling.invalidate();
      },
    });

  return {
    updateSubscriptionItem,
    isLoadingUpdateSubscriptionItem,
    resubscribe,
    isResubscribing,
    chooseFreePlan,
    isChoosingFreePlan,
    changePlan,
    isChangingPlan,
    cancelPendingPlanChange,
    isCancellingPendingPlanChange,
    keepSubscription,
    isKeepingSubscription,
  };
}

export function useUpdateReferral() {
  const utils = trpc.useUtils();

  const { mutate: updateReferral, isPending: isUpdatingReferral } =
    trpc.account.updateReferral.useMutation({
      onSettled() {
        utils.identity.get.invalidate();
      },
    });

  return {
    updateReferral,
    isUpdatingReferral,
  };
}
